import { TimeSeries } from '../../DataSeries';


export function splitParameters(args) {
  let tsParams = {};
  let otherParams = {};

  for (let key of Object.keys(args)) {
    let item = args[key];

    if (item instanceof TimeSeries) {
      tsParams[key] = item;
    } else if (Array.isArray(item)) {
      item.forEach((v,i) => {
        if (v instanceof TimeSeries) {
          tsParams[`_args${i}`] = v;
        } else {
          otherParams[`_args${i}`] = v;
        }
      });
    } else {
      otherParams[key] = item;
    }
  }
  return { tsParams, otherParams };
}

export function mergeParameters(timeseriesParams, otherParams) {
  let output = {};

  let mapper = (obj) => Object.entries(obj).map(([k,v]) => {
    if (k.startsWith('_args')) {
      if (!('args' in output)) output['args'] = [];
      output['args'].push(v);
    } else {
      output[k] = v;
    }
  });

  mapper(timeseriesParams);
  mapper(otherParams);

  return output;
}